import { useEffect, useState } from "react";

import { isFullscreenSupported } from "~/utils/features";
import { isMobileNative } from "~/utils/helpers";

import { useMediaPlayerContext } from "../media/context";
import { VideoControl } from "./VideoControl";

export interface MinimalVideoControlsProps {
  onFullscreenControlClick: () => void;
  onPlayPauseControlClick: () => void;
  onReplayControlClick: () => void;
}

export function MinimalVideoControls({
  onFullscreenControlClick,
  onPlayPauseControlClick,
  onReplayControlClick,
}: MinimalVideoControlsProps) {
  const { ended, fullscreen, paused } = useMediaPlayerContext();

  const [showFullscreenControl, setShowFullscreenControl] = useState(false);

  useEffect(() => {
    setShowFullscreenControl(isFullscreenSupported() || isMobileNative());
  }, []);

  return (
    <div className="VideoControls">
      <div className="VideoControls__utils">
        {showFullscreenControl && (
          <VideoControl
            type="fullscreen"
            isActive={fullscreen}
            onClick={onFullscreenControlClick}
          />
        )}
      </div>

      <div className="VideoControls__playback">
        {!ended && (
          <VideoControl
            type="play-pause"
            isActive={paused}
            onClick={onPlayPauseControlClick}
          />
        )}
        {ended && (
          <VideoControl
            type="replay"
            isActive={paused}
            onClick={onReplayControlClick}
          />
        )}
      </div>
    </div>
  );
}
